import './App.css';
import Header from "./SharedComponents/Header";
import Home from "./Home";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import Quotes from './Quotes'
import Gallery from './Gallery'
import Contact from './Contact'

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            {/* <Route path="/services" element={<Quotes />} /> */}
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;